import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import { isCcpaFlagActive } from '@wetransfer/transfer/component/consent-manager/flags';
import Icon from '@wetransfer/transfer/component/icon';
import Analytics from '@wetransfer/transfer/modules/analytics';
import I18n from '@wetransfer/transfer/modules/i18n';
import Actions from '@wetransfer/transfer/store/action';

export const TermsConditionsExperiment = ({ acceptTermsAndConditions }) => {
  useEffect(() => {
    Analytics.trackSnowplowEvent({
      category: 'terms_conditions_transfer_window',
      action: 'show_tac_in_transfer_window',
    });
  }, []);

  const grantConsent = () => {
    Analytics.trackSnowplowEvent({
      category: 'terms_conditions_transfer_window',
      action: 'click_give_consent_tranfer_window',
      label: 'i_agree',
    });
    acceptTermsAndConditions();
  };

  const introText = isCcpaFlagActive()
    ? 'transfer.terms_conditions.experiment.ustitle'
    : 'transfer.terms_conditions.experiment.title';

  const introClassnames = classNames('terms_intro', {
    'terms_intro--usa': isCcpaFlagActive(),
  });

  return (
    <div className="transfer__window terms-conditions">
      <div className="transfer__contents">
        <div className="terms_logo">
          <Icon
            type="Logo"
            shadow={true}
            className="spinner__logo"
            width={28}
          />
        </div>
        <h1
          className={introClassnames}
          dangerouslySetInnerHTML={{
            __html: I18n.t(introText, {
              options: ' data-route-type="plus"',
            }),
          }}
        />
        <p
          className="terms_info"
          dangerouslySetInnerHTML={{
            __html: I18n.t('transfer.terms_conditions.experiment.text', {
              options: ' data-route-type="plus"',
            }),
          }}
        />
      </div>
      <div className="transfer__footer">
        <button
          className="transfer__button"
          onClick={grantConsent}
          tabIndex="0"
        >
          {I18n.t('transfer.terms_conditions.button')}
        </button>
      </div>
    </div>
  );
};

TermsConditionsExperiment.propTypes = {
  acceptTermsAndConditions: PropTypes.func.isRequired,
  session: PropTypes.object.isRequired,
};

const mapStateToProps = ({ session }) => ({ session });

export const mapDispatchToProps = (dispatch) => ({
  acceptTermsAndConditions: () => {
    dispatch(Actions.Session.acceptTermsConditions());
    dispatch(Actions.Notification.clearTransfer());
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TermsConditionsExperiment);
